import { Inject, Injectable } from '@angular/core';
import { LoiHttpClient } from 'loi-lti-common';
import { Observable } from 'rxjs';
import { SeriesMeetingModel, MeetingSeriesDetails } from '../models/seriesmeeting.model';
import { CustomRequestOptions } from '../utils/custom-request-options';

@Injectable({
  providedIn: 'root'
})

export class SeriesMeetingService {
  constructor(
    private httpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private requestOptions: CustomRequestOptions) { }

  getMeetings(moduleId: string): Observable<MeetingSeriesDetails[]> {
    console.log(`retreiving meetings for module ${moduleId}`);
    return this.httpClient.get<MeetingSeriesDetails[]>(`${this.baseUrl}api/Meeting/${moduleId}`, this.requestOptions);
  }
}
